// Per-platform outgoing TEXT length limit — frontend half.
//
// The numbers are only a FALLBACK: the authoritative map lives in
// chat-server/helpers/messageLimitHelper.js and reaches the store through GET /message-limits, so
// the composer's counter and the controller's 400 cannot drift. The fallback keeps the composer
// working when that fetch is slow or fails. The functions are shared so that neither composer, the
// draft-review overlay nor AdminChat duplicates the arithmetic or the copy.

// BeNeatConversation is DELIBERATELY ABSENT — do NOT "fix" this by adding a value. BeNeat has no
// documented ceiling and no limit in production today, so a number here would start rejecting
// messages that send fine. The omission makes getTextLimit() return null = "no limit" everywhere.
export const DEFAULT_TEXT_LIMITS = {
  LineAtConversation: 5000,
  PrivateConversation: 1999
}

// All three keys on purpose: a platform with no limit still needs a name.
export const DEFAULT_PLATFORM_LABELS = {
  LineAtConversation: 'LINE',
  PrivateConversation: 'Facebook',
  BeNeatConversation: 'แอป BeNeat'
}

const NEUTRAL_RATIO = 0.8
const WARNING_RATIO = 0.95

/**
 * UTF-16 code units, character-for-character the same implementation as the backend helper. No trim,
 * no normalize, no byte check — the count must be taken on the exact string that will be POSTed.
 */
export function countMessageLength (text) {
  return (typeof text === 'string') ? text.length : 0
}

export function getTextLimit (conversationType, limitsFromStore) {
  const limits = (limitsFromStore && Object.keys(limitsFromStore).length) ? limitsFromStore : DEFAULT_TEXT_LIMITS
  const limit = limits[conversationType]
  return (typeof limit === 'number') ? limit : null
}

export function getPlatformLabel (conversationType, labelsFromStore) {
  const labels = (labelsFromStore && Object.keys(labelsFromStore).length) ? labelsFromStore : DEFAULT_PLATFORM_LABELS
  return labels[conversationType] || ''
}

/**
 * 'none' = no limit on this platform, 'hidden' = empty draft; every other state is a VISIBLE band.
 * The meter shows for every non-empty draft on purpose — under the old "hidden below 80%" rule the
 * platform name and its ceiling were invisible for essentially every real message. Recorded user
 * decision: do NOT "restore" the hidden band.
 */
export function getLimitState (length, limit) {
  if (typeof limit !== 'number') return 'none'
  if (length > limit) return 'over'
  if (length > WARNING_RATIO * limit) return 'warning'
  if (length >= NEUTRAL_RATIO * limit) return 'neutral'
  if (length > 0) return 'idle'
  return 'hidden'
}

export function formatCount (value) {
  return Number(value || 0).toLocaleString('th-TH')
}

// ---------------------------------------------------------------------------
// Copy — defined once so the two skins, the overlay and the transcript cannot word the same state
// differently.
// ---------------------------------------------------------------------------

export function counterText (length, limit) {
  const base = `${formatCount(length)} / ${formatCount(limit)} ตัวอักษร`
  if (length > limit) return `${base} (เกิน ${formatCount(length - limit)})`
  return base
}

export function warningText (platformLabel) {
  return `ข้อความยาวเกินที่ ${platformLabel} รับได้ กรุณาแบ่งส่งเป็นหลายข้อความ`
}

/** Word for word the wording of the server's own 400 body. */
export function blockedSendDetail (length, limit, platformLabel) {
  return `ข้อความยาว ${formatCount(length)} ตัวอักษร เกินขีดจำกัดของ ${platformLabel} ที่ ${formatCount(limit)} ตัวอักษร`
}

/** Visually-hidden live region only, announced once on crossing 80%. Never rendered on screen. */
export function nearLimitAnnouncement (limit, platformLabel) {
  return `ใกล้ถึงขีดจำกัดของ ${platformLabel} ที่ ${formatCount(limit)} ตัวอักษร`
}
